import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'controllers/network/apiClient';

export interface TFNHistoryEntry {
  id: number;
  shopId: number;
  phoneSid: string;
  assignedAt: string | null;
  unassignedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ShopTFNHistoryResponse {
  history: TFNHistoryEntry[];
}

const SHOP_TFN_HISTORY_KEY = 'shop_tfn_history';

async function getShopTFNHistory(): Promise<ShopTFNHistoryResponse> {
  return api.get('/v2/messaging/shop_tfn_history');
}

export function useShopTFNHistory(): UseQueryResult<ShopTFNHistoryResponse> {
  return useQuery({
    queryKey: [SHOP_TFN_HISTORY_KEY],
    queryFn: getShopTFNHistory,
    staleTime: 1000 * 60, // 1 minute
  });
}
